var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "faultBack-app-container",
      staticStyle: { position: "relative", height: "100%", padding: "15px" },
    },
    [
      _vm.isTravel
        ? _c(
            "el-card",
            { staticClass: "box-card" },
            [
              _c(
                "el-form",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.formLoading,
                      expression: "formLoading",
                    },
                  ],
                  ref: "form",
                  attrs: { model: _vm.formData },
                },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "標題大綱",
                        "label-width": _vm.formLabelWidth,
                        prop: "title",
                        rules: [
                          {
                            required: true,
                            message: "請輸入標題大綱",
                            trigger: "blur",
                          },
                        ],
                      },
                    },
                    [
                      _c("el-input", {
                        attrs: {
                          autocomplete: "off",
                          maxlength: "100",
                          "show-word-limit": "",
                          placeholder: "請簡單描述...",
                        },
                        model: {
                          value: _vm.formData.title,
                          callback: function ($$v) {
                            _vm.$set(_vm.formData, "title", $$v)
                          },
                          expression: "formData.title",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "詳細內容",
                        "label-width": _vm.formLabelWidth,
                        prop: "describe",
                        rules: [
                          {
                            required: true,
                            message: "請輸入詳細內容",
                            trigger: "blur",
                          },
                        ],
                      },
                    },
                    [
                      _c("el-input", {
                        attrs: {
                          type: "textarea",
                          autosize: { minRows: 8, maxRows: 10 },
                          placeholder:
                            "請詳細輸入內容，您的回饋是我們最大的進步動力！",
                        },
                        model: {
                          value: _vm.formData.describe,
                          callback: function ($$v) {
                            _vm.$set(_vm.formData, "describe", $$v)
                          },
                          expression: "formData.describe",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "截圖畫面",
                        "label-width": _vm.formLabelWidth,
                      },
                    },
                    [
                      _c(
                        "div",
                        [
                          _c("Upload", {
                            ref: "uploadRef",
                            attrs: {
                              accept: ".jpg,.jpeg,.png",
                              payload: _vm.formData,
                              limitText:
                                "如有錯誤畫面請截圖提供給我們以利系統修正，圖片須為.jpg,.jpeg,.png格式，限制不超過2000MB",
                              "data-obj": _vm.fileObj,
                              "limit-file-count": 3,
                              "use-drag": false,
                              action: "appManage/saveFaultBack",
                              "auto-upload": false,
                              "show-file-list": true,
                              "form-on-loading-parent": _vm.formLoading,
                              "btn-txt": "上傳",
                              "before-file-list":
                                _vm.formData.fileInfo &&
                                _vm.formData.fileInfo.length
                                  ? _vm.formData.fileInfo[0].files
                                  : [],
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  ),
                  _c(
                    "el-form-item",
                    { staticStyle: { "text-align": "right" } },
                    [
                      _c(
                        "el-button",
                        {
                          staticStyle: { color: "#4b4b4b" },
                          attrs: { type: "warning" },
                          on: {
                            click: function ($event) {
                              return _vm.submitForm("form")
                            },
                          },
                        },
                        [_vm._v("儲 存")]
                      ),
                      _c(
                        "el-button",
                        {
                          on: {
                            click: function ($event) {
                              return _vm.resetForm()
                            },
                          },
                        },
                        [_vm._v("取 消")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      !_vm.isTravel
        ? _c(
            "el-form",
            { staticClass: "filter-form", attrs: { inline: true } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "團號" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "輸入團號" },
                    model: {
                      value: _vm.listQuery.qry,
                      callback: function ($$v) {
                        _vm.$set(_vm.listQuery, "qry", $$v)
                      },
                      expression: "listQuery.qry",
                    },
                  }),
                ],
                1
              ),
              _c("el-button", {
                staticStyle: { "margin-top": "8px", "margin-left": "5px" },
                attrs: {
                  type: "primary",
                  icon: "el-icon-search",
                  circle: "",
                  disabled: _vm.listLoading,
                },
                on: { click: _vm.getList },
              }),
              _c("el-button", {
                staticStyle: { cursor: "pointer" },
                attrs: {
                  type: "success",
                  loading: _vm.listLoading,
                  circle: "",
                  icon: "el-icon-refresh-left",
                },
                on: {
                  click: function ($event) {
                    return _vm.refresh()
                  },
                },
              }),
            ],
            1
          )
        : _vm._e(),
      !_vm.isTravel
        ? _c(
            "div",
            { staticStyle: { position: "relative", height: "80%" } },
            [
              _c(
                "el-table",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.listLoading,
                      expression: "listLoading",
                    },
                  ],
                  staticStyle: { width: "100%" },
                  attrs: {
                    data: _vm.list,
                    size: "mini",
                    border: "",
                    fit: "",
                    "highlight-current-row": "",
                    height: "100%",
                  },
                },
                [
                  _c("el-table-column", {
                    attrs: { align: "center", label: "ID", width: "40" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (ref) {
                            var row = ref.row
                            return [_c("span", [_vm._v(_vm._s(row.id))])]
                          },
                        },
                      ],
                      null,
                      false,
                      889004969
                    ),
                  }),
                  _c("el-table-column", {
                    attrs: { align: "center", label: "團號", width: "200" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (ref) {
                            var row = ref.row
                            return [
                              _c("span", [_vm._v(_vm._s(row.tourGroupNo))]),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      835639014
                    ),
                  }),
                  _c("el-table-column", {
                    attrs: { align: "center", label: "提交人", width: "200" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (ref) {
                            var row = ref.row
                            return [_c("span", [_vm._v(_vm._s(row.buildUser))])]
                          },
                        },
                      ],
                      null,
                      false,
                      2488174211
                    ),
                  }),
                  _c("el-table-column", {
                    attrs: { align: "center", label: "畫面", width: "100" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              scope.row.fileInfo !== null &&
                              scope.row.fileInfo.length > 0
                                ? _c("el-image", {
                                    staticStyle: { height: "50px" },
                                    attrs: {
                                      src:
                                        scope.row.fileInfo !== null &&
                                        scope.row.fileInfo.length > 0
                                          ? scope.row.fileInfo[0].files[0].url
                                          : "https://fakeimg.pl/280x160/",
                                      fit: "contain",
                                      "preview-src-list": _vm.fileUrl(
                                        scope.row.fileInfo
                                      ),
                                    },
                                  })
                                : _c("span", [_vm._v("無")]),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      21024643
                    ),
                  }),
                  _c("el-table-column", {
                    attrs: { align: "center", label: "標題大綱", width: "200" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (ref) {
                            var row = ref.row
                            return [_c("span", [_vm._v(_vm._s(row.title))])]
                          },
                        },
                      ],
                      null,
                      false,
                      1914559620
                    ),
                  }),
                  _c("el-table-column", {
                    attrs: { align: "center", label: "詳細內容", width: "350" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (ref) {
                            var row = ref.row
                            return [
                              _c("el-input", {
                                attrs: {
                                  rows: 6,
                                  type: "textarea",
                                  disabled: "",
                                  value: row.describe,
                                },
                              }),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      31050468
                    ),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      align: "center",
                      label: "建立時間",
                      sortable: "custom",
                      width: "120",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (ref) {
                            var row = ref.row
                            return [
                              _c("span", [
                                _vm._v(_vm._s(_vm.dataTime(row.buildDate))),
                              ]),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      527592258
                    ),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      align: "center",
                      label: "更新時間",
                      sortable: "custom",
                      width: "120",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (ref) {
                            var row = ref.row
                            return [
                              _c("span", [
                                _vm._v(_vm._s(_vm.dataTime(row.updateDate))),
                              ]),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      2516321957
                    ),
                  }),
                  _c("el-table-column", {
                    attrs: { align: "center", label: "更新人", width: "120" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (ref) {
                            var row = ref.row
                            return [
                              _c("span", [_vm._v(_vm._s(row.updateUser))]),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      2703566724
                    ),
                  }),
                  _c("el-table-column", {
                    attrs: { align: "center", label: "編輯" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c(
                                "el-button",
                                {
                                  staticClass: "filter-item",
                                  attrs: {
                                    type: "primary",
                                    size: "mini",
                                    disabled: scope.row.isSolved,
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.editData(scope.row)
                                    },
                                  },
                                },
                                [_vm._v("標記")]
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      4172785758
                    ),
                  }),
                  _c("el-table-column", {
                    attrs: { align: "center", label: "刪除" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c(
                                "el-button",
                                {
                                  staticClass: "filter-item",
                                  attrs: { size: "mini", type: "danger" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.deleteData(scope.row)
                                    },
                                  },
                                },
                                [_vm._v(" 刪除 ")]
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      826651768
                    ),
                  }),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _c("pagination", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.total > 0,
            expression: "total > 0",
          },
        ],
        attrs: {
          layout: "total, prev, pager, next",
          total: _vm.total,
          page: _vm.listQuery.page,
          limit: _vm.listQuery.limit,
        },
        on: {
          "update:page": function ($event) {
            return _vm.$set(_vm.listQuery, "page", $event)
          },
          "update:limit": function ($event) {
            return _vm.$set(_vm.listQuery, "limit", $event)
          },
          pagination: _vm.getList,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }